import { KYMW0700Model } from './../kymw0700.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品文字情報取得クラス
 *
 * @export GetTextInfoService
 * @class GetTextInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetTextInfoService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW0700Model;
  private vo: any;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetTextInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        GoodsCode: this.vo.goodsCode,
        TextKindId: this.vo.textKindId,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetTextInfoService
   */
  execute(model: KYMW0700Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getTextInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetTextInfoService
   */
  success(data: any): void {
    // サーバからの結果を元に、商品文字情報データを更新する
    this.model.updateTextInfo(data);

    // 設定ボタンの活性・非活性を判定
    this.model.kymw0700Component.checkBtnSetEnable();
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
